import { SxProps, Theme } from "@mui/material";

export const tableContainerSx: SxProps<Theme> = {
  height: "calc(95vh - 220px)",
  minHeight: 400,
  typography: "body1",
};

export const tableDescriptionStyle: React.CSSProperties = {
  padding: "12px 16px",
  borderBottom: "1px solid #eee",
  marginTop: "-22px",
  fontSize: "13px",
};

export const alertSx: SxProps<Theme> = {
  mb: 1,
};
